import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TableMaintenanceSchedules from "./components/TableMaintenanceSchedules";

function MaintenanceSchedulesPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <TableMaintenanceSchedules />
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

export default MaintenanceSchedulesPage